import { render, staticRenderFns } from "./title.vue?vue&type=template&id=356fbbb2&"
import script from "./title.vue?vue&type=script&lang=ts&"
export * from "./title.vue?vue&type=script&lang=ts&"
import style0 from "./title.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports